import { ExternalLink } from "@octopusdeploy/design-system-components";
import { LearnMoreResources, TopicsContainer } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonViews";
export const InsightsReportListTopics = () => (<TopicsContainer>
        <LearnMoreResources>
            <div>
                <ExternalLink href="InsightsReports">Insights Reports</ExternalLink>
            </div>
        </LearnMoreResources>
    </TopicsContainer>);
